import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import BloodflowMark from '../../Assets/BloodflowLogoNoLetters.png';
import PrrLogosBar from '../../Assets/prrLogosBar.png';

const FUNDING_TEXT =
  'O investimento do Health Innovation - Fundo de Capital de Risco Fechado na Ideias Artificiais, Lda., apoiado pelo PRR e financiado pela União Europeia, no âmbito do Programa Consolidar promovido pelo Banco Português de Fomento, S.A., destina-se ao desenvolvimento e expansão da plataforma BloodFlow, uma solução de inteligência clínica integrada nos sistemas de informação de saúde, visando tornar a interpretação de dados clínicos mais rápida, consistente e fundamentada.';

const Footer = () => {
  const { t } = useTranslation();

  return (
    <footer
      style={{
        background: 'var(--bf-bg)',
        borderTop: '1px solid var(--bf-rule)',
      }}
    >
      <div className="bf-container" style={{ padding: '64px 40px 40px' }}>
        <div
          className="bf-footer-grid"
          style={{
            display: 'grid',
            gridTemplateColumns: '2fr 1fr 1fr 1fr',
            gap: 56,
            paddingBottom: 48,
            borderBottom: '1px solid var(--bf-rule)',
          }}
        >
          {/* Brand + pitch */}
          <div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
              <img
                src={BloodflowMark}
                alt=""
                style={{ height: 72, width: 'auto', display: 'block' }}
              />
              <span
                style={{
                  fontFamily: 'var(--bf-sans)',
                  fontSize: 26,
                  fontWeight: 650,
                  letterSpacing: '-0.03em',
                  color: 'var(--bf-ink)',
                  lineHeight: 1,
                }}
              >
                BloodFlow
              </span>
            </div>
            <p className="bf-body-p" style={{ marginTop: 20, fontSize: 14.5, maxWidth: '40ch' }}>
              {t(
                'footer.companyDescription',
                'BloodFlow is a deterministic clinical decision support layer that computes the patient record and writes evidence-based outputs directly into the EMR.'
              )}
            </p>
          </div>

          {/* Product */}
          <div>
            <div className="bf-small">{t('footer.product', 'Product')}</div>
            <div style={{ marginTop: 14, display: 'flex', flexDirection: 'column', gap: 10 }}>
              <a href="#emr-showcase" className="bf-footer-link">{t('navbar.inside', 'Inside your EMR')}</a>
              <a href="#problem" className="bf-footer-link">{t('navbar.problem', 'Problem')}</a>
              <a href="#how" className="bf-footer-link">{t('footer.howItWorks', 'How it works')}</a>
            </div>
          </div>

          {/* Company */}
          <div>
            <div className="bf-small">{t('footer.company', 'Company')}</div>
            <div style={{ marginTop: 14, display: 'flex', flexDirection: 'column', gap: 10 }}>
              <Link to="/careers" className="bf-footer-link">{t('footer.careers', 'Careers')}</Link>
              <Link to="/contact-sales" className="bf-footer-link">{t('footer.contactSales', 'Contact sales')}</Link>
              <a href="mailto:support@bloodflow.ai" className="bf-footer-link">{t('footerEmail', 'support@bloodflow.ai')}</a>
              <a href="#press" className="bf-footer-link">{t('footer.press', 'Press')}</a>
            </div>
          </div>

          {/* Legal */}
          <div>
            <div className="bf-small">{t('footer.legal', 'Legal')}</div>
            <div style={{ marginTop: 14, display: 'flex', flexDirection: 'column', gap: 10 }}>
              <a
                href="https://drive.google.com/file/d/1YBFUR6iIhu-v2t83AvJLdngwKhRhg7ec/view?usp=drive_link"
                target="_blank"
                rel="noopener noreferrer"
                className="bf-footer-link"
              >
                {t('footer.privacy', 'Privacy policy')}
              </a>
              <span className="bf-footer-link">{t('footer.terms', 'Terms of service')}</span>
              <span className="bf-footer-link">{t('gdprCompliant', 'GDPR compliance')}</span>
            </div>
          </div>
        </div>

        <div
          style={{
            paddingTop: 24,
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            flexWrap: 'wrap',
            gap: 16,
          }}
        >
          <div className="bf-small" style={{ color: 'var(--bf-ink)', textTransform: 'none', letterSpacing: '0.02em' }}>
            {t('footer.tagline', 'Clinical intelligence, embedded.')}
          </div>
          <div className="bf-small">
            © {new Date().getFullYear()} BloodFlow · {t('footer.addressShort', 'Lisbon · Porto')}
          </div>
        </div>

        <div className="bf-funding">
          <img
            src={PrrLogosBar}
            alt="Financiado pelo PRR e pela União Europeia — NextGeneration EU · República Portuguesa"
            className="bf-funding-logos"
          />
          <p className="bf-funding-text">{FUNDING_TEXT}</p>
        </div>
      </div>

      <style>{`
        .bf-footer-link {
          font-family: var(--bf-sans);
          font-size: 14px;
          color: var(--bf-muted);
          text-decoration: none;
          transition: color 0.15s;
          cursor: pointer;
        }
        .bf-footer-link:hover { color: var(--bf-ink); }
        @media (max-width: 900px) {
          .bf-footer-grid { grid-template-columns: 1fr 1fr !important; gap: 40px !important; }
        }
        @media (max-width: 540px) {
          .bf-footer-grid { grid-template-columns: 1fr !important; gap: 32px !important; }
        }
        .bf-funding {
          margin-top: 32px;
          padding-top: 28px;
          border-top: 1px solid var(--bf-rule);
        }
        .bf-funding-logos {
          width: 100%;
          max-width: 560px;
          height: auto;
          display: block;
          opacity: 0.9;
        }
        .bf-funding-text {
          margin-top: 18px;
          font-family: var(--bf-sans);
          font-size: 12px;
          line-height: 1.6;
          color: var(--bf-muted);
          max-width: 130ch;
        }
      `}</style>
    </footer>
  );
};

export default Footer;
